import { ExternalLink, Mail, ShieldQuestion, HeartHandshake } from "lucide-react";

export default function PartnerStrip() {
  return (
    <section data-testid="partner-strip" className="border-t border-white/10 bg-[#0B0F18]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <p className="text-center font-code text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-5">
          Allied Services Standing With P.A.I.N.
        </p>
        <div className="grid gap-4 sm:grid-cols-2 max-w-3xl mx-auto">
          <a
            href="https://bem-crisis.app"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="partner-strip-bem"
            className="card-pain flex items-center gap-4 p-4"
          >
            <span className="flex items-center justify-center h-11 w-11 shrink-0 rounded-lg bg-[#1D4ED8]/20 border border-amber-500/25">
              <ShieldQuestion className="h-5 w-5 text-amber-400" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-display text-sm sm:text-base font-semibold text-slate-50">
                Behind Every Mask
              </span>
              <span className="block text-xs text-slate-400 truncate">
                Free anonymous crisis app — press for help now
              </span>
            </span>
            <ExternalLink className="h-4 w-4 text-amber-400 shrink-0" />
          </a>
          <a
            href="mailto:enquiries@harmonyharbour.co.uk"
            data-testid="partner-strip-harmony"
            className="card-pain flex items-center gap-4 p-4"
          >
            <span className="flex items-center justify-center h-11 w-11 shrink-0 rounded-lg bg-[#1D4ED8]/20 border border-amber-500/25">
              <HeartHandshake className="h-5 w-5 text-amber-400" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-display text-sm sm:text-base font-semibold text-slate-50">
                Harmony Harbour UK
              </span>
              <span className="block text-xs text-slate-400 truncate">
                24/7 mental health support — you are not alone
              </span>
            </span>
            <Mail className="h-4 w-4 text-amber-400 shrink-0" />
          </a>
        </div>
      </div>
    </section>
  );
}
